import React, { Component } from "react";
import "./GbrFormsComponent.css";
import BuyInput from "../gbrEngage/BuyInput/BuyInput";
import GovtSchemesComponent from "../gbrEngage/GovtSchemes/GovtSchemes";
import PriceDiscovery from "../gbrEngage/PriceDiscovery/PriceDiscovery";
import ClubUpdates from "../gbrEngage/ClubUpdates/ClubUpdates";
import AdvisaryCBNComponent from "../gbrEngage/Advisary/AdvisaryCBN";
import AdvertisementCBN from "../gbrEngage/Advertisement/AdvertisementCBN";
import JobsComponent from "../gbrEngage/Jobs/Jobs";
import SiteWeatherManagement from "../SiteWeatherManagement/SiteWeatherManagement";
import HomeSubSection from "../WebSite/HomeSubSection/HomeSubSection";

// GbrFormsComponent class to render the GBR Care platform sections
class GbrFormsComponent extends Component {
  render() {
    return (
      <>
        {/* Main container for GBR Care platform forms */}
        <div className="subSectionWrapper">
          <div className="update-container-wrapper">

            {/* Section: Advertisements for Machinery Providers */}
            <h3 className="container-title text-center">Advertisements</h3>
            <HomeSubSection
              className1="aboutBgGrey"
              className="rowReverseAbout--mod borderedCards borderedCards--mod"
              className3="image19"
              descriptionTitle="Machinery Providers"
              description="
                GBR Care collaborates with leading machinery providers to support farmers 
                by showcasing their advertisements and promoting the latest technology."
            />
            {/* Advertisement Listings */}
            <AdvertisementCBN />

            {/* Section: Advisory for Farmers */}
            <h3 className="container-title text-center">Advisory</h3>
            <HomeSubSection
              className="rowReverseAbout borderedCards borderedCards--mod"
              className3="image16"
              description="Advisors can join GBR Care and provide expertise on animal husbandry, plant cultivation, 
              and machinery to help farmers improve their practices."
              descriptionTitle="Farmers' Advisors"
              buttoncont7="Sign up"
              onClick={() => {
                localStorage.setItem("userType", "MSME-ADVISOR");
              }}
              href7="/auth/3/signup"
              href4="http://abn.gbrfarming.com/"
              buttoncont1="Sign In"
              userType="Trainer"
            />
            {/* Advisory Content */}
            <AdvisaryCBNComponent />

            {/* Section: Buy Inputs from Input Manufacturers */}
            <h3 className="container-title text-center">Buy Inputs</h3>
            <HomeSubSection
              className="rowReverseAbout--mod borderedCards borderedCards--mod"
              className3="image20"
              description="GBR Care purchases and distributes products from input manufacturers 
              to ensure farmers receive quality inputs for livestock and crops."
              descriptionTitle="Input Manufacturers"
              description1="Nutrition Companies | Agri Input Companies"
            />
            {/* Input Purchase Component */}
            <BuyInput />

            {/* Section: Government Schemes Information */}
            <h3 className="container-title text-center">Govt Schemes</h3>
            <HomeSubSection
              className1="aboutBgGrey"
              className="rowReverseAbout--mod borderedCards borderedCards--mod"
              className3="image6"
              descriptionTitle="Government Organizations"
              description="GBR Care promotes government schemes and initiatives to farmers, 
              ensuring they are informed about available agricultural support programs."
            />
            {/* Government Schemes Content */}
            <GovtSchemesComponent />

            {/* Section: Jobs listing */}
            <div className="mb-lg-5 mb-4">
              <JobsComponent />
            </div>

            {/* Section: Price Discovery Platform */}
            <div className="mb-lg-5 mb-4">
              <PriceDiscovery />
            </div>

            {/* Section: Club Updates */}
            <div className="mb-lg-5 mb-4">
              <ClubUpdates />
            </div>

            {/* Section: Weather Updates tailored to farm locations */}
            <div className="mb-lg-5 mb-4">
              <h3 className="container-title text-center">Weather Updates</h3>
              <HomeSubSection
                className="rowReverseAbout borderedCards borderedCards--mod"
                className3="image16"
                description="Farmers can join GBR Care and access site-specific weather updates 
                to better plan and manage farming activities."
                descriptionTitle="Farmers"
                buttoncont7="Sign up"
                onClick={() => {
                  localStorage.setItem("userType", "MSME-ADVISOR");
                }}
                href7="/auth/3/signup"
                href4="http://abn.gbrfarming.com/"
                buttoncont1="Sign In"
                userType="Trainer"
              />
              {/* Weather management component */}
              <SiteWeatherManagement />
            </div>

          </div>
        </div>
      </>
    );
  }
}

// Exporting the component for use in other parts of the application
export default GbrFormsComponent;
